import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Col, Flex, Form, FormProps, Row } from 'antd';

// components
import ComponentHeader from 'components/componentHeader/componentHeader';

// services

// models
import FormPassword from 'components/formPassword/formPassword';
import { updatePassword } from '../services/profileService';
import NotificationService from 'core/services/notification';
import { mapResponseErrors } from 'utils/mapResponseErrors';

const ProfileChangePasswordComponent: FunctionComponent = () => {
	const { t } = useTranslation();

	const [profileForm] = Form.useForm();
	const [isLoading, setIsLoading] = useState(false);

	type FieldType = {
		current_password: string;
		password: string;
		password_confirmation: string;
	};

	const validatePassword = (_: any, value: string) => {
		if (!value || profileForm.getFieldValue('password') === value) {
			return Promise.resolve();
		}
		return Promise.reject(new Error(t('COMMON.PASSWORDS_NOT_MATCH')));
	};

	const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
		try {
			setIsLoading(true);

			await updatePassword(values);

			NotificationService.success(t('COMMON.SUCCESS'), t('PROFILE.PASSWORD_CHANGED'));

			profileForm.resetFields();

			setIsLoading(false);
		} catch (error: any) {
			setIsLoading(false);
			mapResponseErrors(error, profileForm);
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.SUBMIT_ERROR'));
		}
	};

	return (
		<>
			<Card>
				<Row>
					<Col span={24} lg={8}>
						<ComponentHeader title={t('PROFILE.USER_PROFILE_INF')} subtitle={t('PROFILE.UPDATE_YOUR_PROFILE')} />
					</Col>
					<Col span={24} lg={16}>
						<Flex vertical gap={20}>
							<Form form={profileForm} name="profileForm" onFinish={onFinish}>
								<FormPassword
									name="current_password"
									label={t('COMMON.CURRENT_PASSWORD')}
									rules={[{ required: true, message: t('COMMON.PASSWORD_REQUIRED') }]}
								/>

								<FormPassword
									name="password"
									label={t('COMMON.PASSWORD')}
									rules={[{ required: true, message: t('COMMON.PASSWORD_REQUIRED') }]}
								/>

								<FormPassword
									name="password_confirmation"
									label={t('COMMON.PASSWORD_CONFIRMATION')}
									rules={[{ required: true, message: t('COMMON.PASSWORD_REQUIRED') }, { validator: validatePassword }]}
								/>

								<Form.Item style={{ marginTop: 40 }}>
									<Button block type="primary" htmlType="submit" loading={isLoading} disabled={isLoading}>
										{t('COMMON.UPDATE')}
									</Button>
								</Form.Item>
							</Form>
						</Flex>
					</Col>
				</Row>
			</Card>
		</>
	);
};

export default ProfileChangePasswordComponent;
